/**
 * @generated SignedSource<<ca4cfc3370307efafe1e63330580672e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoDetailQuery$variables = {
  todoId: string;
};
export type TodoDetailQuery$data = {
  readonly todo: {
    readonly " $fragmentSpreads": FragmentRefs<"TodoDetailContent_todo">;
  } | null;
};
export type TodoDetailQuery = {
  response: TodoDetailQuery$data;
  variables: TodoDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formattedBody",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isIssue",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "style",
      "value": "DEFAULT"
    }
  ],
  "kind": "ScalarField",
  "name": "storeFormattedDate",
  "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "createdAtDate",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoSubject",
  "kind": "LinkedField",
  "name": "subject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectBreadcrumb",
      "kind": "LinkedField",
      "name": "allBreadcrumbs",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requiredToDescribeTodo",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v15 = [
  (v2/*: any*/)
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrg",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkedToViewer",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "workStatus",
  "storageKey": null
},
v21 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "thumbhash",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageSize",
    "kind": "LinkedField",
    "name": "sizes",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v12/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isPublicAndInternalImage"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "publicImageUrl",
          "storageKey": null
        }
      ],
      "type": "PublicImage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v21/*: any*/),
      "type": "Image",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  (v2/*: any*/),
  (v13/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v23/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "EmployeeRole",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v13/*: any*/),
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": (v15/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employees",
      "plural": true,
      "selections": (v23/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v30 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isActor"
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v22/*: any*/),
    (v20/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgDescription",
  "kind": "LinkedField",
  "name": "orgDescription",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "orgIconUri",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = [
  (v13/*: any*/),
  (v2/*: any*/)
],
v35 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": (v34/*: any*/),
      "storageKey": null
    }
  ],
  "type": "ScreenActor",
  "abstractKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v22/*: any*/),
    (v20/*: any*/),
    (v2/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "identifyingName",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "createdByActor",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v30/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            (v31/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v2/*: any*/),
                (v32/*: any*/),
                (v33/*: any*/)
              ],
              "storageKey": null
            },
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    (v35/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v36/*: any*/),
        (v37/*: any*/),
        (v38/*: any*/)
      ],
      "type": "GroupActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v36/*: any*/),
        (v37/*: any*/)
      ],
      "type": "ConnectActor",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v40 = [
  {
    "kind": "Literal",
    "name": "last",
    "value": 30
  }
],
v41 = [
  (v2/*: any*/),
  (v13/*: any*/)
],
v42 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v26/*: any*/)
],
v43 = [
  (v2/*: any*/),
  (v13/*: any*/),
  (v26/*: any*/),
  (v10/*: any*/)
],
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v32/*: any*/),
    (v2/*: any*/),
    (v33/*: any*/)
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeStatus",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feedbackStatus",
  "storageKey": null
},
v50 = [
  (v31/*: any*/)
],
v51 = [
  (v18/*: any*/),
  (v30/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StoreUser",
        "kind": "LinkedField",
        "name": "storeUser",
        "plural": false,
        "selections": [
          (v31/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": (v34/*: any*/),
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "UserActor",
    "abstractKey": null
  },
  (v35/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v50/*: any*/),
    "type": "GroupActor",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v50/*: any*/),
    "type": "ConnectActor",
    "abstractKey": null
  }
],
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TodoDetailContent_todo"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoDetailQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v9/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "images",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "minHeight",
                    "value": 699
                  },
                  {
                    "kind": "Literal",
                    "name": "minWidth",
                    "value": 699
                  }
                ],
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "size",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": "size(minHeight:699,minWidth:699)"
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreProduct",
            "kind": "LinkedField",
            "name": "linkedProducts",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "partNumber",
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "formattedSize",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FilePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreZonedDate",
            "kind": "LinkedField",
            "name": "expireAtDate",
            "plural": false,
            "selections": [
              (v17/*: any*/),
              (v7/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedEmployee",
            "kind": "LinkedField",
            "name": "assigned",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v18/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssignedRole",
            "kind": "LinkedField",
            "name": "assignedRoles",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v18/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategoryTag",
            "kind": "LinkedField",
            "name": "tags",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v26/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "teams",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v13/*: any*/),
              (v26/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v2/*: any*/),
                  (v26/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v39/*: any*/),
          {
            "alias": null,
            "args": (v40/*: any*/),
            "concreteType": "TodoTimelineConnection",
            "kind": "LinkedField",
            "name": "timeline",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoTimelineEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isTodoTimelineItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "comment",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v39/*: any*/),
                          (v9/*: any*/)
                        ],
                        "type": "TodoComment",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": true,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isTodoTimelineUpdateEvent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "addedAssignedEmployees",
                                    "plural": true,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "removedAssignedEmployees",
                                    "plural": true,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventAssignedEmployees",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newTitle",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventTitle",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newBody",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventBody",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newStatus",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventStatus",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "newPriority",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventPriority",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TodoCategory",
                                    "kind": "LinkedField",
                                    "name": "newCategory",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventCategory",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreZonedDate",
                                    "kind": "LinkedField",
                                    "name": "newExpireAt",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventExpireAt",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TodoCategoryTag",
                                    "kind": "LinkedField",
                                    "name": "addedTodoTags",
                                    "plural": true,
                                    "selections": (v42/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TodoCategoryTag",
                                    "kind": "LinkedField",
                                    "name": "removedTodoTags",
                                    "plural": true,
                                    "selections": (v42/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventTags",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "addedAssignedTeams",
                                    "plural": true,
                                    "selections": (v43/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Team",
                                    "kind": "LinkedField",
                                    "name": "removedAssignedTeams",
                                    "plural": true,
                                    "selections": (v43/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventAssignedTeams",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EmployeeRole",
                                    "kind": "LinkedField",
                                    "name": "addedAssignedRoles",
                                    "plural": true,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "EmployeeRole",
                                    "kind": "LinkedField",
                                    "name": "removedAssignedRoles",
                                    "plural": true,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "TodoTimelineUpdateEventAssignedRoles",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "createdByActor",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              (v30/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreUser",
                                    "kind": "LinkedField",
                                    "name": "storeUser",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Employee",
                                        "kind": "LinkedField",
                                        "name": "employee",
                                        "plural": false,
                                        "selections": [
                                          (v13/*: any*/),
                                          (v2/*: any*/),
                                          (v22/*: any*/),
                                          (v20/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v44/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UserActor",
                                "abstractKey": null
                              },
                              (v35/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "employee",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v2/*: any*/),
                                      (v18/*: any*/),
                                      (v22/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v37/*: any*/),
                                  (v38/*: any*/)
                                ],
                                "type": "GroupActor",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v37/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Employee",
                                    "kind": "LinkedField",
                                    "name": "employee",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v2/*: any*/),
                                      (v22/*: any*/),
                                      (v20/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ConnectActor",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TodoTimelineUpdate",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v39/*: any*/),
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoContact",
                            "kind": "LinkedField",
                            "name": "contact",
                            "plural": false,
                            "selections": [
                              (v32/*: any*/),
                              (v45/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "type": "TodoFeedback",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": "timeline(last:30)"
          },
          {
            "alias": null,
            "args": (v40/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "TodoDetailTimeline__timeline",
            "kind": "LinkedHandle",
            "name": "timeline"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "subTodos",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v46/*: any*/),
              (v29/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "response",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v47/*: any*/)
                    ],
                    "type": "TodoResponseImage",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v28/*: any*/),
              (v16/*: any*/),
              (v5/*: any*/),
              (v4/*: any*/),
              (v48/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "expireAtDate",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              (v6/*: any*/),
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoContact",
                "kind": "LinkedField",
                "name": "contact",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v45/*: any*/),
                  (v32/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v49/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedEmployee",
                "kind": "LinkedField",
                "name": "assigned",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "assignedAt",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  (v2/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignedRole",
                "kind": "LinkedField",
                "name": "assignedRoles",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v2/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v26/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProduct",
                "kind": "LinkedField",
                "name": "linkedProducts",
                "plural": true,
                "selections": [
                  (v13/*: any*/),
                  (v2/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Todo",
                "kind": "LinkedField",
                "name": "subTodos",
                "plural": true,
                "selections": [
                  (v46/*: any*/),
                  (v2/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "commentCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expireAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isResponseCompleted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreZonedDate",
                "kind": "LinkedField",
                "name": "resolvedAtDate",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "lastChangedStatusByActor",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": null
              },
              (v47/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeToResolvedFormatted",
                "storageKey": null
              },
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "createdByActor",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  (v30/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreUser",
                        "kind": "LinkedField",
                        "name": "storeUser",
                        "plural": false,
                        "selections": [
                          (v52/*: any*/),
                          (v44/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "UserActor",
                    "abstractKey": null
                  },
                  (v35/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Employee",
                        "kind": "LinkedField",
                        "name": "employee",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v2/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v37/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "GroupActor",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v37/*: any*/),
                      (v52/*: any*/)
                    ],
                    "type": "ConnectActor",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v46/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "response",
            "plural": false,
            "selections": [
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v48/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v32/*: any*/),
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v49/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoFeedback",
            "kind": "LinkedField",
            "name": "allTodoFeedbacks",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "createdByActor",
                "plural": false,
                "selections": (v51/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8f26bb382b9f6156454596aeebffd0a3",
    "id": null,
    "metadata": {},
    "name": "TodoDetailQuery",
    "operationKind": "query",
    "text": "query TodoDetailQuery(\n  $todoId: ID!\n) {\n  todo(id: $todoId) {\n    ...TodoDetailContent_todo\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment Avatar_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        ...Avatar_employee\n        id\n      }\n      user {\n        name\n        ...Avatar_user\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    ...Avatar_groupActor\n  }\n  ... on ConnectActor {\n    __typename\n    ...Avatar_connectActor\n  }\n}\n\nfragment Avatar_connectActor on ConnectActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_employee on Employee {\n  image {\n    __typename\n    ...ImagePublicOrPrivate_image\n    ... on Image {\n      id\n    }\n  }\n  workStatus\n  name\n}\n\nfragment Avatar_groupActor on GroupActor {\n  employee {\n    name\n    ...Avatar_employee\n    id\n  }\n}\n\nfragment Avatar_user on User {\n  name\n}\n\nfragment CreatedBySubject_actor on Actor {\n  __isActor: __typename\n  ...SignedActorCompact_actor\n}\n\nfragment ImagePublicOrPrivate_image on PublicAndInternalImage {\n  __isPublicAndInternalImage: __typename\n  ... on PublicImage {\n    ...ImagePublic_image\n    __typename\n  }\n  ... on Image {\n    id\n    ...Image_image\n    __typename\n  }\n}\n\nfragment ImagePublic_image on PublicImage {\n  publicImageUrl\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedProducts_products on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment ListItemAssignees_employees on Employee {\n  id\n  ...ListItemEmployees_employees\n}\n\nfragment ListItemAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment ListItemEmployees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ListItemRoles_roles on EmployeeRole {\n  id\n  name\n  isLinkedToViewer\n  employeeIds\n  team {\n    id\n  }\n  employees {\n    id\n    name\n    isLinkedToViewer\n    workStatus\n    ...Avatar_employee\n  }\n}\n\nfragment SignalDetailFiles_files on File {\n  id\n  name\n  formattedSize\n  type\n  pages {\n    id\n  }\n}\n\nfragment SignedActorBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on ConnectActor {\n    employee {\n      __typename\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n}\n\nfragment SignedActorCompactBadge_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    storeUser {\n      user {\n        orgDescription {\n          orgIconUri\n        }\n        id\n      }\n      id\n    }\n    __typename\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      __typename\n      id\n    }\n    user {\n      __typename\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n  }\n  ... on ConnectActor {\n    __typename\n  }\n}\n\nfragment SignedActorCompact_actor on Actor {\n  __isActor: __typename\n  ...SignedActorText_actor\n  ...SignedActorCompactBadge_actor\n}\n\nfragment SignedActorText_actor on Actor {\n  __isActor: __typename\n  ... on UserActor {\n    __typename\n    storeUser {\n      employee {\n        name\n        id\n      }\n      user {\n        name\n        email\n        id\n      }\n      id\n    }\n  }\n  ... on ScreenActor {\n    __typename\n    screen {\n      name\n      id\n    }\n  }\n  ... on GroupActor {\n    __typename\n    employee {\n      name\n      id\n    }\n    identifyingName\n  }\n  ... on ConnectActor {\n    __typename\n    identifyingName\n    employee {\n      name\n      id\n    }\n  }\n}\n\nfragment SignedActor_actor on Actor {\n  __isActor: __typename\n  ...Avatar_actor\n  ...SignedActorText_actor\n  ...SignedActorBadge_actor\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TVTodoPopovers_todo on Todo {\n  ...TodoEditPrioPopover_todo\n  ...TodoEditTagsPopover_todo\n  id\n  teams {\n    id\n  }\n  assignedRoles {\n    id\n    role {\n      id\n      team {\n        id\n      }\n    }\n  }\n}\n\nfragment TVTodoSubListItem_todo on Todo {\n  id\n  status\n  ordinal\n  response {\n    __typename\n  }\n  canWrite\n  isOrg\n  body\n  formattedBody\n  canChangeStatus\n  expireAtDate {\n    isoString\n  }\n  ...TodoListItemMainContentText_todo\n  ...TodoListItemPriority_todo\n  ...TodoListItemFooter_todo\n  ...TodoOverviewListItemMediumStatusAndPrio_Todo\n  ...TodoListItemMainContentDetails_todo\n  ...TodoListItemHeader_todo\n}\n\nfragment TodoContact_todo on Todo {\n  contact {\n    name\n    email\n    phoneNumber\n    address\n  }\n  feedbackStatus\n  allTodoFeedbacks {\n    createdByActor {\n      __typename\n      ...Avatar_actor\n    }\n    id\n  }\n}\n\nfragment TodoDetailContentMain_todo on Todo {\n  id\n  title\n  formattedBody\n  body\n  isIssue\n  ...TodoEditNewMainCreationInfo\n  ...TodoDetailImages_todo\n  linkedProducts {\n    ...LinkedProducts_products\n    id\n  }\n  files {\n    ...SignalDetailFiles_files\n    id\n  }\n}\n\nfragment TodoDetailContent_todo on Todo {\n  ...TodoDetailContentMain_todo\n  ...TodoDetailToolbar_todo\n  ...TodoDetailTimeline_todo\n  ...TVTodoPopovers_todo\n  ...TodoEditNewMainCreationInfo\n  ...TodoDetailImages_todo\n  ...TodoDetailSubTodos_todo\n  ...TodoContact_todo\n}\n\nfragment TodoDetailImages_todo on Todo {\n  images {\n    size(minHeight: 699, minWidth: 699) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment TodoDetailSubTodos_todo on Todo {\n  subTodos {\n    id\n    ...TVTodoSubListItem_todo\n    status\n  }\n  ...TodoEditNewMainPreventDefault_todo\n}\n\nfragment TodoDetailTimeline_todo on Todo {\n  ...TodoTimelineUpdateEventCreated_todo\n  createdByActor {\n    __typename\n  }\n  timeline(last: 30) {\n    edges {\n      node {\n        __typename\n        ...TodoTimeline_item\n        ... on TodoComment {\n          id\n        }\n        ... on TodoFeedback {\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      hasPreviousPage\n      startCursor\n    }\n  }\n  id\n}\n\nfragment TodoDetailToolbar_todo on Todo {\n  ...TodoToolbarEdit_todo\n  ...TVTodoPopovers_todo\n}\n\nfragment TodoEditNewMainCreationInfo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n}\n\nfragment TodoEditNewMainPreventDefault_todo on Todo {\n  id\n  status\n  response {\n    __typename\n  }\n  subTodos {\n    status\n    __typename\n    id\n  }\n  canChangeStatus\n  category {\n    title\n    id\n  }\n}\n\nfragment TodoEditPrioPopover_todo on Todo {\n  id\n  priority\n  ...useTodoEditSetPrio_todo\n}\n\nfragment TodoEditTagsPopover_todo on Todo {\n  id\n  tags {\n    id\n  }\n  category {\n    tags {\n      id\n      color\n      title\n    }\n    id\n  }\n}\n\nfragment TodoListItemAssignedUsers_todo on Todo {\n  assigned {\n    assignedAt\n    employee {\n      id\n      ...ListItemAssignees_employees\n    }\n    id\n  }\n  assignedRoles {\n    role {\n      id\n      ...ListItemAssignees_roles\n    }\n    id\n  }\n}\n\nfragment TodoListItemCompletedInfo_todo on Todo {\n  resolvedAtDate {\n    ...StoreFormattedDate\n  }\n  lastChangedStatusByActor {\n    __typename\n    ...Avatar_actor\n  }\n}\n\nfragment TodoListItemContact_todo on Todo {\n  contact {\n    name\n    phoneNumber\n    email\n  }\n  feedbackStatus\n}\n\nfragment TodoListItemFooterDone_todo on Todo {\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n}\n\nfragment TodoListItemFooterPending_todo on Todo {\n  ...TodoListItemAssignedUsers_todo\n  ...TodoListItemContact_todo\n  feedbackStatus\n  contact {\n    __typename\n  }\n  expireAtDate {\n    ...StoreFormattedDate\n    isoString\n  }\n  tags {\n    ...TodoListItemTags_tag\n  }\n  assigned {\n    __typename\n    id\n  }\n  assignedRoles {\n    __typename\n    id\n  }\n  linkedProducts {\n    ...TodoListItemProducts_StoreProduct\n    id\n  }\n  ...TodoListItemFooterSubTodos_todo\n  subTodos {\n    __typename\n    id\n  }\n  commentCount\n}\n\nfragment TodoListItemFooterSubTodos_todo on Todo {\n  id\n  subTodos {\n    status\n    id\n  }\n}\n\nfragment TodoListItemFooter_todo on Todo {\n  ...TodoListItemFooterDone_todo\n  ...TodoListItemFooterPending_todo\n  status\n}\n\nfragment TodoListItemHeaderWrapper_todo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  timeToResolvedFormatted\n}\n\nfragment TodoListItemHeader_todo on Todo {\n  ...TodoListItemHeaderWrapper_todo\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n  title\n  isIssue\n  createdByActor {\n    __typename\n    ...CreatedBySubject_actor\n  }\n}\n\nfragment TodoListItemMainContentDetails_todo on Todo {\n  ...TodoListItemCompletedInfo_todo\n  status\n  images {\n    id\n    ...Image_image\n  }\n  linkedProducts {\n    imageUrl\n    id\n  }\n}\n\nfragment TodoListItemMainContentText_todo on Todo {\n  title\n  isIssue\n  status\n}\n\nfragment TodoListItemPriority_todo on Todo {\n  priority\n  status\n}\n\nfragment TodoListItemProducts_StoreProduct on StoreProduct {\n  name\n}\n\nfragment TodoListItemTags_tag on TodoCategoryTag {\n  id\n  color\n  title\n}\n\nfragment TodoOverviewListItemMediumStatusAndPrio_Todo on Todo {\n  canWrite\n  id\n  status\n  priority\n  expireAt\n  isResponseCompleted\n  ordinal\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n  }\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n\nfragment TodoTagButtonContentActive_todoCategoryTag on TodoCategoryTag {\n  id\n  title\n  color\n}\n\nfragment TodoTimelineComment_todoComment on TodoComment {\n  comment\n  id\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineFeedback_feedback on TodoFeedback {\n  title\n  body\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  contact {\n    email\n    phoneNumber\n    name\n  }\n}\n\nfragment TodoTimelineUpdateEventBody_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    addedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    removedAssignedEmployees {\n      id\n      ...TodoTimelineUpdateEventEmployee_employee\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    newTitle\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    newBody\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    newCategory {\n      title\n      id\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n    newExpireAt {\n      ...StoreFormattedDate\n    }\n  }\n  ... on TodoTimelineUpdateEventTags {\n    addedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    removedTodoTags {\n      id\n      ...TodoTimelineUpdateEventTag_tag\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    addedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    removedAssignedTeams {\n      id\n      ...TodoTimelineUpdateEventTeam_team\n    }\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    addedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    removedAssignedRoles {\n      id\n      ...TodoTimelineUpdateEventRole_role\n    }\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventCreated_todo on Todo {\n  createdByActor {\n    __typename\n    ...SignedActor_actor\n  }\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n}\n\nfragment TodoTimelineUpdateEventEmployee_employee on Employee {\n  name\n}\n\nfragment TodoTimelineUpdateEventIcon_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ... on TodoTimelineUpdateEventAssignedEmployees {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTitle {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventBody {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n    __typename\n  }\n  ... on TodoTimelineUpdateEventPriority {\n    newPriority\n    __typename\n  }\n  ... on TodoTimelineUpdateEventCategory {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventExpireAt {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventTags {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedTeams {\n    __typename\n  }\n  ... on TodoTimelineUpdateEventAssignedRoles {\n    __typename\n  }\n}\n\nfragment TodoTimelineUpdateEventRole_role on EmployeeRole {\n  name\n}\n\nfragment TodoTimelineUpdateEventTag_tag on TodoCategoryTag {\n  title\n  color\n}\n\nfragment TodoTimelineUpdateEventTeam_team on Team {\n  name\n  color\n  icon\n  ...AHTeamIcon\n}\n\nfragment TodoTimelineUpdateEvent_event on TodoTimelineUpdateEvent {\n  __isTodoTimelineUpdateEvent: __typename\n  __typename\n  ...TodoTimelineUpdateEventIcon_event\n  ...TodoTimelineUpdateEventBody_event\n  ... on TodoTimelineUpdateEventStatus {\n    newStatus\n  }\n}\n\nfragment TodoTimelineUpdateEvent_timelineItem on TodoTimelineUpdate {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  createdByActor {\n    __typename\n    ...SignedActorCompact_actor\n    ...SignedActor_actor\n  }\n}\n\nfragment TodoTimelineUpdate_todoTimelineUpdate on TodoTimelineUpdate {\n  events {\n    __typename\n    ...TodoTimelineUpdateEvent_event\n  }\n  ...TodoTimelineUpdateEvent_timelineItem\n}\n\nfragment TodoTimeline_item on TodoTimelineItem {\n  __isTodoTimelineItem: __typename\n  ... on TodoComment {\n    ...TodoTimelineComment_todoComment\n    __typename\n  }\n  ... on TodoTimelineUpdate {\n    __typename\n    ...TodoTimelineUpdate_todoTimelineUpdate\n  }\n  ... on TodoFeedback {\n    __typename\n    ...TodoTimelineFeedback_feedback\n  }\n}\n\nfragment TodoToolbarButtonTags_tags on TodoCategoryTag {\n  ...TodoTagButtonContentActive_todoCategoryTag\n}\n\nfragment TodoToolbarButtonTeamsDetail_teams on Team {\n  id\n  ...AHTeamIconCircle\n}\n\nfragment TodoToolbarButtonTeams_teams on Team {\n  id\n  name\n  ...TodoToolbarButtonTeamsDetail_teams\n}\n\nfragment TodoToolbarEdit_todo on Todo {\n  isOrg\n  expireAtDate {\n    isoString\n    storeFormattedDate(style: DEFAULT)\n    __typename\n  }\n  assigned {\n    employee {\n      ...ToolbarButtonAssignees_employees\n      id\n    }\n    __typename\n    id\n  }\n  assignedRoles {\n    role {\n      ...ToolbarButtonAssignees_roles\n      id\n    }\n    __typename\n    id\n  }\n  tags {\n    ...TodoToolbarButtonTags_tags\n    __typename\n  }\n  teams {\n    ...TodoToolbarButtonTeams_teams\n    id\n  }\n  category {\n    tags {\n      __typename\n    }\n    id\n  }\n  priority\n  canWrite\n}\n\nfragment ToolbarButtonAssignees_employees on Employee {\n  id\n  name\n  isLinkedToViewer\n  workStatus\n  ...Avatar_employee\n}\n\nfragment ToolbarButtonAssignees_roles on EmployeeRole {\n  id\n  ...ListItemRoles_roles\n}\n\nfragment useTodoEditSetPrio_todo on Todo {\n  id\n  priority\n  ordinal\n}\n"
  }
};
})();

(node as any).hash = "d1c03411c08d8defdfaeb61e59752035";

export default node;
